import dynamic from "next/dynamic";
import SlimLogosConfig from "./slim-logos-config";
import SlimLogosAdvancedConfig from "./slim-logos-advanced-config";
const SlimLogosComponent = dynamic(()=>import("./slim-logos-component"));
export default {
    SlimLogosComponent,
    SlimLogosConfig,
    SlimLogosAdvancedConfig
};
